export enum ProjectWiseModules {
    Projects = 'projectslist',
    Tasks = 'taskslist'
}